import userStore from "./userStore";
import tenantsStore from "./tenantsStore";
import repairPagesStore from "./repairPagesStore";



const stores = {
  userStore,
  tenantsStore,
  repairPagesStore,
};

export { userStore, tenantsStore, repairPagesStore };

export default stores;

